import Select, { type DropdownIndicatorProps, components, SingleValue } from 'react-select'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface StartThreadButtonProps {
    options: any[]
    onChange(newValue: SingleValue<any>): void
    disabled?: boolean
    buttonTitle?: string
}

const StartThreadButton = ({
    onChange,
    options,
    disabled = false,
    buttonTitle = 'Contact'
}: StartThreadButtonProps) => {
    const customControlStyles = (base: any) => ({
        ...base,
        fontSize: '0.9rem',
        cursor: 'pointer',
        minHeight: 35,
        color: 'var(--tb-blushPrimary-cc)',
        backgroundColor: 'var(--tb-blushPrimary)',
        borderColor: 'var(--tb-fadedPrimary)'
    })

    const customCaretStyles = (base: any) => ({
        ...base,
        color: 'var(--tb-primary-cc)'
    })

    const customMenuStyles = (base: any) => ({
        ...base,
        width: 'max-content',
        fontSize: '0.9rem',
        minWidth: '100%',
        right: 0
    })

    const CaretDownIcon = () => {
        return <DynamicFaIcon iconName='plus' className='text-[--tb-primary] hover:text-[--tb-text-light]' />
    }

    // added type if using typescript
    const DropdownIndicator: React.FC<DropdownIndicatorProps> = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <CaretDownIcon />
            </components.DropdownIndicator>
        )
    }

    return (
        <Select
            value={''}
            onChange={(newValue: SingleValue<any>) => onChange(newValue)}
            options={options}
            isDisabled={disabled}
            defaultValue={''}
            menuPlacement='auto'
            menuPosition='fixed'
            placeholder={
                <span className={'text-[--tb-blushPrimary-cc] flex items-center'}>
                    <DynamicFaIcon className='mr-2' iconName='message' />{' '}
                    <span className='hidden xl:inline'>{buttonTitle}</span>
                </span>
            }
            className='relative'
            components={{ DropdownIndicator }}
            isSearchable={false}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary25: 'var(--tb-blushPrimary)',
                    primary: 'var(--tb-primary)'
                }
            })}
            styles={{ control: customControlStyles, dropdownIndicator: customCaretStyles, menu: customMenuStyles }}
        />
    )
}

export default StartThreadButton
